import React from 'react'
import { useHistory } from 'react-router-dom'
import ButtonNew from '~/Common-Objects/UI/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import i18n from '~/i18n'
import LandingPagePicker from '../includes/landingPagePicker'

export default function AddLandingPage() {
    const history = useHistory()
    const goToList = () => history.push('/cp/landingpages')

    return (
        <div className='landing-page-add'>
            <Paper className='landing-page-add__modal'>
                <ButtonNew
                    variant='ghost'
                    size='s'
                    iconOnly
                    className='landing-page-add__close'
                    aria-label={i18n.t('form:landingPages.add.close')}
                    data-tooltip-id='landing-page-add-close'
                    data-tooltip-content={i18n.t('form:landingPages.add.close')}
                    data-tooltip-place='left'
                    iconLeft={<Icons icon='cross' color='currentColor' />}
                    onClick={goToList}
                />
                <LandingPagePicker onCancel={goToList} />
            </Paper>
        </div>
    )
}
